import { motion } from "framer-motion";
import { TESTIMONIALS } from "../../lib/content";

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-36 border-t border-white/5" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="tag-glass"><span className="dot" /> The room speaks</div>
          <h2 className="font-display text-white text-4xl md:text-6xl leading-[1.02] tracking-tight mt-6">
            What the founders <br />and CMOs <span className="italic-accent text-grad-crimson">say</span>.
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.07 }}
              className="card-lux rounded-2xl p-8 md:p-10 flex flex-col justify-between min-h-[320px]"
              data-testid={`testimonial-${i}`}
            >
              <div className="font-display text-[#e63946] text-6xl leading-none">&ldquo;</div>
              <blockquote className="mt-4 text-white/85 text-lg md:text-xl leading-relaxed font-display">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-white/10">
                <div className="text-white text-sm">{t.name}</div>
                <div className="overline mt-1">{t.role}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
